const state = {
    message: null,
    syncing: null,
    upgrade: false,
    offline: !window.navigator.onLine,
    error: null,
    snackbar: null,
}
const mutations = {
    SET_MESSAGE (state, data) {

        if(typeof(data) === 'object') {
            state.message = data
        } else {
            state.message = {
                message: data,
                flash: false
            }
        }
    },
    SET_SYNCING (state, data) {
        state.syncing = data
    },
    SHOW_UPGRADE (state) {
        state.upgrade = true
    },
    CANCEL_UPGRADE (state) {
        state.upgrade = false
    },
    SET_OFFLINE (state, data) {
        state.offline = data
    },
    SET_ERROR (state, data) {
        if(data && typeof data === 'object' && !data.header) {
            data.header = 'Error'
        }
        if(data && typeof data === 'object' && !data.button) {
            data.button = 'Close'
        }
        state.error = data
    },
    SET_SNACKBAR (state, data) {
        if(!data && state.snackbar && state.snackbar.nag > 0) {
            var snack = state.snackbar
            setTimeout(() => state.snackbar = snack, state.snackbar.nag*1000)
        }
        state.snackbar = data
    }
}

const actions = {
    setError({commit}, value) {
        commit('SET_ERROR', value)
    },
    setMessage({commit}, value) {
        commit('SET_MESSAGE', value)
    },
    setSnackbar({commit}, value) {
        commit('SET_SNACKBAR', value)
    },
    setNetworkError({dispatch}) {
        dispatch('setError', {header: 'Network Error', text: 'There is a network error, please make sure you are connected to the internet', button: 'Ok'})
    }
}

const getters = {
    message: state => { return state.message },
    offline: state => { return state.offline }
}

export default {
    namespaced: true, state, mutations, actions, getters
}
